import type { UpcomingInvoicesReportItem } from '@vy/types';
import { CONTRACT_STATUSES, INVOICE_BILLING_STATUSES, INVOICE_REVIEW_STATUSES } from '@vy/types';
import { useMemo } from 'react';
import type { FilterField } from '../../../../components/new-design/vyTableFilter';
import {
  buildCustomerFilterField,
  collectIdNameOptions,
  filterNonEmptySelectFields,
  MULTISELECT_OPERATORS,
} from '../../reports-components/shared-filter-fields';

export const BILLING_FORECAST_FILTER_FIELD_IDS = Object.freeze({
  CustomerId: 'customerId',
  ContractStatus: 'contractStatus',
  ReviewStatus: 'reviewStatus',
  BillingStatus: 'billingStatus',
});

export function useBillingForecastFilterFields(
  reportItems: UpcomingInvoicesReportItem[],
): FilterField[] {
  return useMemo(() => {
    const customers = collectIdNameOptions(
      reportItems.map((item) => ({ id: item.customer.id, name: item.customer.name })),
    );

    const allFields: FilterField[] = [
      buildCustomerFilterField(customers),
      {
        id: BILLING_FORECAST_FILTER_FIELD_IDS.ContractStatus,
        label: 'Contract Status',
        inputType: 'select',
        operators: MULTISELECT_OPERATORS,
        options: Object.values(CONTRACT_STATUSES).map((status) => ({ value: status, label: status })),
      },
      {
        id: BILLING_FORECAST_FILTER_FIELD_IDS.ReviewStatus,
        label: 'Invoice Review Status',
        inputType: 'select',
        operators: MULTISELECT_OPERATORS,
        options: Object.values(INVOICE_REVIEW_STATUSES).map((status) => ({ value: status, label: status })),
      },
      {
        id: BILLING_FORECAST_FILTER_FIELD_IDS.BillingStatus,
        label: 'Invoice Billing Status',
        inputType: 'select',
        operators: MULTISELECT_OPERATORS,
        options: Object.values(INVOICE_BILLING_STATUSES).map((status) => ({ value: status, label: status })),
      },
    ];

    return filterNonEmptySelectFields(allFields);
  }, [reportItems]);
}
